// src/components/module/compras/components/HeaderSection.tsx
// Rediseño corporativo estilo Notion/Linear
import React, { useContext } from "react";
import { Box, Typography, Stack } from "@mui/material";
import { Person, Phone, Email } from "@mui/icons-material";
import { DarkModeContext } from "../../../../context/darkModeContext";

const P = {
  light: { bg: "#FFFFFF", bgS: "#F7F7F5", bgT: "#F1F1EF", text: "#37352F", textS: "#6B6B6B", textT: "#9B9A97", border: "#E9E9E7", accent: "#2383E2", accentBg: "#E8F0FE" },
  dark: { bg: "#191919", bgS: "#202020", bgT: "#2B2B2B", text: "#E8E8E6", textS: "#9B9A97", textT: "#6B6B6B", border: "#333333", accent: "#529CCA", accentBg: "#143A52" },
};

interface HeaderSectionProps {
  empresa: { Nombre: string };
  proveedor: { Nombre: string; Telefono?: string; Correo?: string };
}

const HeaderSection: React.FC<HeaderSectionProps> = ({ empresa, proveedor }) => {
  const { darkMode } = useContext(DarkModeContext);
  const p = darkMode ? P.dark : P.light;

  const InfoItem: React.FC<{ icon: React.ReactElement; label: string; value: string }> = ({ icon, label, value }) => (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <Box sx={{
        width: 34, height: 34, borderRadius: "8px", bgcolor: p.bgT,
        display: "flex", alignItems: "center", justifyContent: "center",
        color: p.textT, "& svg": { fontSize: 16 },
      }}>
        {icon}
      </Box>
      <Box>
        <Typography sx={{ fontSize: "0.7rem", fontWeight: 600, color: p.textT, textTransform: "uppercase", letterSpacing: "0.04em" }}>
          {label}
        </Typography>
        <Typography sx={{ fontSize: "0.88rem", fontWeight: 500, color: p.text }}>
          {value}
        </Typography>
      </Box>
    </Stack>
  );

  return (
    <Box sx={{
      p: 2.5, borderRadius: "10px", border: `1px solid ${p.border}`, bgcolor: p.bgS,
    }}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={3} justifyContent="space-between">
        <InfoItem icon={<Person />} label="Proveedor" value={proveedor.Nombre} />
        <InfoItem icon={<Phone />} label="Teléfono" value={proveedor.Telefono || "No disponible"} />
        <InfoItem icon={<Email />} label="Correo" value={proveedor.Correo || "No disponible"} />
      </Stack>
    </Box>
  );
};

export default HeaderSection;
